<template>
  <div id="app">
    <el-header></el-header>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <el-footer></el-footer>
  </div>
</template>

<script>
import elHeader from './components/Header'
import elFooter from './components/Footer'
export default {
  name: 'app',
  components: {
    elHeader, elFooter
  },
  mounted () {
    let lang = (navigator.language || navigator.browserLanguage).toLowerCase()
    // 繁体中文
    if (lang === 'zh-hk' || lang === 'zh-mo' || lang === 'zh-tw') {
      lang = 'zh-td'
    }
    switch (lang) {
      case ('zh-td'):
        this.$i18n.locale = 'td'
        break
      case ('zh-cn'):
        this.$i18n.locale = 'cn'
        break
      default:
        this.$i18n.locale = 'en'
    }
    console.log('当前语言：' + lang)
  }
}
</script>

<style lang="scss">
// 动画
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}

#app {
  font-family: "Open Sans,sans-serif";
  font-weight: 300;
  color: #494f53;
  line-height: 1.5;
  -moz-osx-font-smoothing: grayscale;
  .main {
    margin-top: 0.6rem;
    font-size: 0.1em
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?10096932